module.exports = __webpack_public_path__ + "img/transporter-4.5722b49d.svg";